function setVisible(state, isVisible) {
  state.isVisible = isVisible;
}

function setProposition(state, proposition) {
  state.proposition = proposition;
}

export default { setVisible, setProposition };
